module.exports = __webpack_public_path__ + "static/img/btn-satisfaction-1-b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/btn-satisfaction-1-b.png
// module id = 517
// module chunks = 0